import { useNavigate } from "react-router-dom";
import { App } from "antd";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { UseFormReturn } from "react-hook-form";

import { useRegisterMutation } from "@/redux/service";
import { handleErrors, snakeToCamelAttr } from "@/shared/utils/forms";
import { setAuthenticationState } from "@/redux/authentication/reducer";
import { LocalStorageName } from "@/redux/api";
import { RegisterRequest } from "@/redux/authentication/types";
import { RegisterFormValues, RegisterSubmitError } from "../types";

export const useRegisterSubmit = <T extends RegisterFormValues>(
  form: UseFormReturn<T>,
) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { notification } = App.useApp();
  const { t } = useTranslation();
  const [register, { isLoading }] = useRegisterMutation();

  const submit = (
    payload: RegisterRequest,
    onError?: (submitError: RegisterSubmitError) => void,
  ) =>
    register(payload)
      .unwrap()
      .then((data) => {
        notification.success({
          message: t("auth.messages.registrationSuccess"),
        });
        dispatch(
          setAuthenticationState({ isAuthenticated: true, user: data.user }),
        );
        window.localStorage.setItem(
          LocalStorageName,
          JSON.stringify({
            accessExpiration: data.accessExpiration,
            refreshExpiration: data.refreshExpiration,
            user: data.user,
          }),
        );
        navigate("/");
      })
      .catch((submitError) => {
        onError?.(submitError);
        handleErrors(
          submitError,
          form.setError,
          notification,
          undefined,
          snakeToCamelAttr,
        );
      });

  return { submit, isLoading };
};
